var render = function render(){var _vm=this,_c=_vm._self._c;return _c('llm-sku-create-form',_vm._g(_vm._b({ref:"inner",attrs:{"mode":"create","hide-footer":"","import-mode":"local_path"}},'llm-sku-create-form',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }